import React from 'react'
import ColumnSelector from '../../Table/ColumnSelector'

const GridListThManage = ({ defs, onChange }) => {

  return (
    <th className='viso-grid-list-th viso-grid-list-th--manage'>
      <ColumnSelector
        columns={defs}
        onChange={onChange}
      />
    </th>
  )
}

export default GridListThManage